import { Link } from "react-scroll";
import { useState } from 'react';

// import logo from 'assets/images/icons/logo.svg';

const Header = ({ contacts }) => {
	const [classname, setClassname] = useState('header__body');
	const [isOpenBurger, setIsOpenBurger] = useState(true);

	const contact_1 = contacts.contact_1;
	const contact_2 = contacts.contact_2;
	const durationScroll = 250;

	const menuOpen = () => {
		if (isOpenBurger) {
			document.body.classList.add('_lock');
			setClassname('header__body _open');
		} else {
			document.body.classList.remove('_lock');
			setClassname('header__body');
		}
		setIsOpenBurger(prev => !prev);
	}

	const clickLinkHandler = () => {
		document.body.classList.remove('_lock');
		setClassname('header__body');
	}

	const handleClickOutside = (e) => {
		if (!e.target.classList.contains('menu__list')) {
			document.body.classList.remove('_lock');
			setClassname('header__body');
		}
	}

	return (
		<>
			<header className="wrapper__header header">
				<div className="header__container">
					<div className={classname}>
						<div className="header__logo">
							<img src="assets/images/icons/logo.svg" alt="" />
						</div>
						<div className="header__menu menu">
							<button type="button" className="menu__icon icon-menu" onClick={menuOpen}><span></span></button>
							<nav className="menu__body" onClick={handleClickOutside}>
								<ul className="menu__list">
									<li className="menu__item"><Link to={'section1'} smooth={true} duration={durationScroll} className="menu__link _text-link" onClick={clickLinkHandler}>Профессии</Link></li>
									<li className="menu__item"><Link to={'section2'} smooth={true} duration={durationScroll} className="menu__link _text-link" onClick={clickLinkHandler} >О нас</Link></li>
									<li className="menu__item"><Link to={'section3'} smooth={true} duration={durationScroll} className="menu__link _text-link" onClick={clickLinkHandler}>Кому подходит?</Link></li>
									<li className="menu__item"><Link to={'section4'} smooth={true} duration={durationScroll} className="menu__link _text-link" onClick={clickLinkHandler}>О работе платформы</Link></li>
									<li className="menu__item"><Link to={'section5'} smooth={true} duration={durationScroll} className="menu__link _text-link" onClick={clickLinkHandler}>Отзывы</Link></li>
								</ul>
							</nav>
						</div>
						<div className="header__contacts">
							<a href={`tel:${contact_1}`} className="header__phone _text-link">{contact_1}</a>
							<a href={`tel:${contact_2}`} className="header__phone _text-link">{contact_2}</a>
						</div>
					</div>
				</div>
			</header>
		</>
	)
}

export default Header;